import { getBackendBoolean } from '@Sage/ssm-utils/backendScalars';

export const getOpportunityStateId = (state) => {
    if (state == null) return null;
    if (typeof state === 'object' && 'value' in state) return state.value;
    return state;
};

const isResolvedOpportunityStatus = (status) =>
    Boolean(status && typeof status === 'object' && 'blnendstate' in status);

export const isOpportunityClosedStatus = (status) => {
    if (!isResolvedOpportunityStatus(status)) return false;
    return getBackendBoolean(status.blnendstate);
};

export const isOpportunityClosedRecord = (opportunity) =>
    getBackendBoolean(opportunity?.isWon) || getBackendBoolean(opportunity?.isLost);

export const resolveOpportunityStatus = (statuses, state) => {
    if (isResolvedOpportunityStatus(state)) return state;

    const stateId = getOpportunityStateId(state);
    if (stateId == null || stateId === '' || !Array.isArray(statuses)) return null;

    return statuses.find((item) => String(item.value) === String(stateId)) || null;
};

const hasCloseDateValue = (value) => value !== undefined && value !== null && value !== '';

export const getOpportunityCloseDateFields = ({
    currentCloseDate,
    previousStatus,
    status,
    now = () => new Date(),
}) => {
    // Unknown next status (list not loaded / id not found): do not touch closeDate.
    if (!isResolvedOpportunityStatus(status)) return {};

    if (!isOpportunityClosedStatus(status)) {
        return { closeDate: null };
    }

    if (hasCloseDateValue(currentCloseDate)) {
        const previousResolved = isResolvedOpportunityStatus(previousStatus);
        // Keep the current date when previous is closed, or when we cannot tell.
        // Only overwrite leftovers when we know the previous status was open.
        if (!previousResolved || isOpportunityClosedStatus(previousStatus)) {
            return {};
        }
    }

    return { closeDate: now() };
};

export const getOpportunityCloseDateFieldsFromState = ({
    statuses,
    previousState,
    nextState,
    currentCloseDate,
    now,
}) =>
    getOpportunityCloseDateFields({
        currentCloseDate,
        previousStatus: resolveOpportunityStatus(statuses, previousState),
        status: resolveOpportunityStatus(statuses, nextState),
        now,
    });
